<template>
  <div class="top-bar-wrapper">
    <div class="top-bar-white" :class="{ 'hide-on-digitales': isLibrosDigitales }">
      <div class="top-bar-links">
        <a href="https://atl-sdcas01.sirsidynix.net/aiep_cas_saml/login?service=https%3A%2F%2Faiep.ent.sirsidynix.net%2Fclient%2Fes_CL%2Fdefault%2Fsearch%2Fcasrequest%3F" target="_blank" rel="noopener noreferrer" class="top-link">Estudiantes</a>
        <a href="https://atl-sdcas01.sirsidynix.net/aiep_cas_saml/login?service=https%3A%2F%2Faiep.ent.sirsidynix.net%2Fclient%2Fes_CL%2Fdefault%2Fsearch%2Fcasrequest%3F" target="_blank" rel="noopener noreferrer" class="top-link">Docentes</a>
        <a href="https://atl-sdcas01.sirsidynix.net/aiep_cas_saml/login?service=https%3A%2F%2Faiep.ent.sirsidynix.net%2Fclient%2Fes_CL%2Fdefault%2Fsearch%2Fcasrequest%3F" target="_blank" rel="noopener noreferrer" class="top-link">Colaboradores</a>
      </div>
    </div>
  </div>
  <header class="header">
    <div class="header-container">
      <div class="logo" @click="navigateToHome" style="cursor: pointer;">
        <svg class="logo-text-desktop" width="385" height="67" viewBox="0 0 385 67" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M61.1321 53.2433C60.9724 53.2067 60.8092 53.1885 60.6433 53.1885C60.5365 53.1885 60.4192 53.198 60.2921 53.2163C60.1651 53.2346 60.0592 53.2529 59.9763 53.2711C59.8933 53.2894 59.8024 53.3112 59.7054 53.3355C59.6074 53.3599 59.5554 53.3721 59.5492 53.3721V57.1702H58.3042V52.749C58.4701 52.682 58.771 52.6029 59.2068 52.5115C59.6427 52.4201 60.0618 52.374 60.4651 52.374C60.803 52.374 61.0254 52.3923 61.1321 52.4288V53.2433Z" fill="white"/>
          <path d="M83.8388 34.9793H78.2218L81.0126 26.4659H81.0815L83.8388 34.9793ZM85.6653 40.3001L87.3541 44.9466H94.5559L84.7697 18.2014H77.3959L67.4023 44.9466H74.5697L76.3618 40.3001H85.6653Z" fill="white"/>
          <path d="M102.89 18.2014H96.1357V44.9466H102.89V18.2014Z" fill="white"/>
          <path d="M120.145 24.0896V18.2014H105.362V44.9466H120.145V39.0584H112.117V34.4476H119.732V28.5594H112.117V24.0896H120.145Z" fill="white"/>
          <path d="M129.292 23.8059H130.429C133.048 23.8059 135.288 23.8416 135.288 27.2107C135.288 30.4746 132.876 30.4746 130.429 30.4746H129.292V23.8059ZM122.537 44.9466H129.291V36.0791H133.116C139.007 36.0791 142.316 33.3121 142.316 26.9984C142.316 20.8614 138.457 18.2014 132.874 18.2014H122.537V44.9466Z" fill="white"/>
          <path d="M25.1058 17.8638H9.96289V44.9466H25.1058V17.8638Z" fill="#CE1B1B"/>
          <path d="M64.7364 17.8638H49.7734V44.9466H64.7364V17.8638Z" fill="#CE1B1B"/>
          <path d="M37.44 9.42346L29.2412 17.862V44.9448H45.638V17.862L37.44 9.42346Z" fill="#CE1B1B"/>
          <path d="M20.0024 55.0558H16.8188C16.8303 55.55 16.9503 55.9163 17.1788 56.1539C17.4074 56.3923 17.7788 56.5106 18.295 56.5106C18.5853 56.5106 18.8756 56.4636 19.1668 56.3688C19.4571 56.274 19.6591 56.1843 19.7712 56.0991V56.9231C19.6529 56.9962 19.4112 57.0736 19.0468 57.1563C18.6824 57.2381 18.2862 57.2798 17.86 57.2798C17.0121 57.2798 16.4191 57.071 16.0812 56.6525C15.7432 56.2348 15.5747 55.5866 15.5747 54.7077C15.5747 53.9638 15.7732 53.3886 16.1703 52.9823C16.5674 52.5768 17.1126 52.3732 17.8062 52.3732C18.4935 52.3732 19.0318 52.5794 19.42 52.991C19.8082 53.4034 20.0024 53.9751 20.0024 54.7069V55.0558ZM18.8024 54.3788C18.79 53.9881 18.7 53.6784 18.5315 53.4495C18.3621 53.2207 18.1212 53.1067 17.8071 53.1067C17.1674 53.1067 16.8382 53.5313 16.8197 54.3788H18.8024Z" fill="white"/>
          <path d="M13.3336 52.649C12.978 52.4663 12.5209 52.3749 11.9642 52.3749C11.3774 52.3749 10.8974 52.5759 10.5242 52.9788C10.1509 53.3816 9.96387 53.9585 9.96387 54.7086C9.96387 55.6179 10.1509 56.2739 10.5242 56.6768C10.8974 57.0797 11.4992 57.2807 12.3295 57.2807C13.1359 57.2807 13.8886 57.1493 14.5883 56.8874V50.5537L13.3345 50.9287V52.6499L13.3336 52.649ZM13.3336 56.2913C13.0433 56.4193 12.7115 56.4836 12.3383 56.4836C11.965 56.4836 11.6915 56.3418 11.5203 56.0582C11.3483 55.7745 11.2627 55.3246 11.2627 54.7077C11.2627 53.6888 11.6236 53.1789 12.3471 53.1789C12.4653 53.1789 12.5845 53.1928 12.7027 53.2198C12.8218 53.2476 12.9471 53.2842 13.0803 53.3294C13.2136 53.3755 13.2983 53.4016 13.3336 53.4069V56.2913Z" fill="white"/>
          <path d="M30.3242 56.9683C30.1583 57.0353 29.8645 57.1041 29.4436 57.1745C29.0227 57.245 28.5251 57.2798 27.9498 57.2798C26.5327 57.2798 25.8242 56.7699 25.8242 55.751C25.8242 55.2629 26.036 54.8861 26.4604 54.6207C26.8839 54.3553 27.4133 54.2231 28.0477 54.2231H29.1057V53.9298C29.1057 53.3991 28.6786 53.1337 27.8254 53.1337C27.363 53.1337 26.8204 53.259 26.1983 53.5087V52.7212C26.2098 52.7212 26.2698 52.7047 26.3766 52.6708C26.4833 52.6377 26.5927 52.6064 26.7057 52.5794C26.8186 52.5515 26.9536 52.522 27.1098 52.488C27.2669 52.4541 27.4372 52.4271 27.6207 52.4054C27.8042 52.3845 27.9851 52.3732 28.1633 52.3732C28.916 52.3732 29.4648 52.4985 29.8089 52.7482C30.153 52.9988 30.3242 53.4104 30.3242 53.9838V56.9683ZM29.1057 56.4106V54.8818H28.4563C27.9939 54.8818 27.6472 54.9461 27.416 55.0741C27.1848 55.202 27.0692 55.4221 27.0692 55.7327C27.0692 56.0007 27.1583 56.2052 27.3357 56.3462C27.5139 56.4871 27.7504 56.5568 28.0469 56.5568C28.503 56.5568 28.8569 56.508 29.1057 56.4106Z" fill="white"/>
          <path d="M23.6719 57.1702H24.9169V50.5529L23.6719 50.9244V57.1702Z" fill="white"/>
          <path d="M38.893 54.9366C38.893 55.6875 38.6874 56.2653 38.2753 56.6716C37.8633 57.0771 37.2544 57.2807 36.448 57.2807C35.5709 57.2807 34.9418 57.0806 34.5633 56.6812C34.1838 56.2818 33.9941 55.704 33.9941 54.947V50.947H35.2833V54.7547C35.2833 55.3038 35.3688 55.7066 35.5409 55.9625C35.713 56.2191 36.0147 56.3471 36.448 56.3471C36.8574 56.3471 37.1503 56.2148 37.3286 55.9494C37.5068 55.684 37.595 55.2829 37.595 54.746V50.9479H38.893V54.9383V54.9366Z" fill="white"/>
          <path d="M44.5573 57.1702H43.3035V54.351C43.3035 53.942 43.2312 53.6479 43.0856 53.4678C42.94 53.2877 42.7044 53.198 42.3788 53.198C42.2067 53.198 42.0206 53.218 41.8185 53.2572C41.6173 53.2972 41.4779 53.3381 41.4003 53.3808V57.1702H40.1553V52.7586C40.9026 52.5019 41.6526 52.374 42.4053 52.374C43.0988 52.374 43.6309 52.5019 44.0015 52.7586C44.372 53.0153 44.5573 53.399 44.5573 53.9115V57.1702Z" fill="white"/>
          <path d="M46.9931 57.1701H45.7481V52.4836H46.9931V57.1701ZM45.7305 51.6413H47.0108V50.7076L45.7305 51.0905V51.6413Z" fill="white"/>
          <path d="M52.5156 52.4836L50.9503 57.1702H49.288L47.7227 52.4836H49.0206L50.15 56.3279L51.2618 52.4836H52.5156Z" fill="white"/>
          <path d="M57.3357 55.0558H54.1521C54.1636 55.55 54.2845 55.9163 54.5121 56.1539C54.7407 56.3923 55.1121 56.5106 55.6283 56.5106C55.9186 56.5106 56.2089 56.4636 56.4992 56.3688C56.7895 56.274 56.9915 56.1843 57.1036 56.0991V56.9231C56.9854 56.9962 56.7436 57.0736 56.3792 57.1563C56.0148 57.2381 55.6186 57.2798 55.1915 57.2798C54.3436 57.2798 53.7515 57.071 53.4127 56.6525C53.0748 56.2348 52.9062 55.5866 52.9062 54.7077C52.9062 53.9638 53.1048 53.3886 53.5018 52.9823C53.8989 52.5768 54.4442 52.3732 55.1377 52.3732C55.8251 52.3732 56.3633 52.5794 56.7515 52.991C57.1398 53.4034 57.3339 53.9751 57.3339 54.7069V55.0549L57.3357 55.0558ZM56.1348 54.3788C56.1224 53.9881 56.0324 53.6784 55.8639 53.4495C55.6945 53.2207 55.4536 53.1067 55.1395 53.1067C54.4989 53.1067 54.1707 53.5313 54.1521 54.3788H56.1348Z" fill="white"/>
          <path d="M65.4807 55.7606C65.4807 56.2365 65.3069 56.6089 64.9601 56.8769C64.6133 57.1449 64.1051 57.2798 63.4345 57.2798C62.996 57.2798 62.5998 57.238 62.2478 57.1562C61.8948 57.0736 61.6592 56.9961 61.541 56.923V56.1086C62.0625 56.3775 62.5636 56.5115 63.0436 56.5115C63.4178 56.5115 63.7019 56.4584 63.8978 56.3514C64.0928 56.2443 64.1907 56.1086 64.1907 55.9441C64.1907 55.7919 64.0989 55.6587 63.9154 55.5456C63.7319 55.4325 63.5095 55.3342 63.2483 55.248C62.9872 55.1628 62.7269 55.0662 62.4657 54.96C62.2045 54.853 61.9822 54.699 61.7986 54.498C61.6151 54.297 61.5225 54.0586 61.5225 53.7845C61.5225 53.3451 61.706 53.0005 62.0739 52.7499C62.4419 52.5002 62.9157 52.3749 63.4963 52.3749C64.2136 52.3749 64.8128 52.4906 65.2928 52.7229V53.5287C64.7889 53.2789 64.3142 53.1536 63.8695 53.1536C63.1469 53.1536 62.7851 53.3277 62.7851 53.6757C62.7851 53.8402 62.9254 53.9916 63.2078 54.1291C63.4892 54.2665 63.7972 54.384 64.1325 54.4815C64.4669 54.5789 64.7757 54.7399 65.0572 54.9618C65.3386 55.1845 65.4798 55.4517 65.4798 55.7623L65.4807 55.7606Z" fill="white"/>
          <path d="M67.6854 57.1702H66.4404V52.4836H67.6854V57.1702Z" fill="white"/>
          <path d="M78.7026 56.9683C78.5368 57.0353 78.2429 57.1041 77.822 57.1745C77.4012 57.245 76.9035 57.2798 76.3282 57.2798C74.9112 57.2798 74.2026 56.7699 74.2026 55.751C74.2026 55.2629 74.4144 54.8861 74.8388 54.6207C75.2623 54.3553 75.7918 54.2231 76.4262 54.2231H77.4841V53.9298C77.4841 53.3991 77.057 53.1337 76.2038 53.1337C75.7415 53.1337 75.1988 53.259 74.5768 53.5087V52.7212C74.5882 52.7212 74.6482 52.7047 74.755 52.6708C74.8618 52.6377 74.9712 52.6064 75.0841 52.5794C75.197 52.5515 75.3312 52.522 75.4891 52.488C75.6462 52.4541 75.8165 52.4271 76.0009 52.4054C76.1844 52.3845 76.3653 52.3732 76.5435 52.3732C77.2962 52.3732 77.845 52.4985 78.1882 52.7482C78.5315 52.9988 78.7044 53.4104 78.7044 53.9838V56.9675L78.7026 56.9683ZM77.4841 56.4106V54.8818H76.8347C76.3723 54.8818 76.0256 54.9461 75.7944 55.0741C75.5632 55.202 75.4476 55.4221 75.4476 55.7327C75.4476 56.0007 75.5368 56.2052 75.7141 56.3462C75.8915 56.4871 76.1288 56.5568 76.4253 56.5568C76.8815 56.5568 77.2353 56.508 77.4841 56.4106Z" fill="white"/>
          <path d="M72.0513 52.649C71.6958 52.4663 71.2387 52.3749 70.6819 52.3749C70.0952 52.3749 69.6152 52.5759 69.2419 52.9788C68.8687 53.3816 68.6816 53.9585 68.6816 54.7086C68.6816 55.6179 68.8687 56.2739 69.2419 56.6768C69.6152 57.0797 70.2169 57.2807 71.0472 57.2807C71.8537 57.2807 72.6064 57.1493 73.3061 56.8874V50.5537L72.0522 50.9287V52.6499L72.0513 52.649ZM72.0513 56.2913C71.7611 56.4193 71.4293 56.4836 71.0561 56.4836C70.6828 56.4836 70.4093 56.3418 70.2381 56.0582C70.0661 55.7745 69.9805 55.3246 69.9805 54.7077C69.9805 53.6888 70.3414 53.1789 71.0649 53.1789C71.1831 53.1789 71.3022 53.1928 71.4205 53.2198C71.5396 53.2476 71.6649 53.2842 71.7981 53.3294C71.9314 53.3755 72.0161 53.4016 72.0513 53.4069V56.2913Z" fill="white"/>
          <path d="M83.0328 52.649C82.6772 52.4663 82.2201 52.3749 81.6634 52.3749C81.0766 52.3749 80.5966 52.5759 80.2234 52.9788C79.8501 53.3816 79.6631 53.9585 79.6631 54.7086C79.6631 55.6179 79.8501 56.2739 80.2234 56.6768C80.5966 57.0797 81.1984 57.2807 82.0287 57.2807C82.8351 57.2807 83.5878 57.1493 84.2875 56.8874V50.5537L83.0337 50.9287V52.6499L83.0328 52.649ZM83.0328 56.2913C82.7425 56.4193 82.4107 56.4836 82.0366 56.4836C81.6625 56.4836 81.3898 56.3418 81.2187 56.0582C81.0466 55.7745 80.961 55.3246 80.961 54.7077C80.961 53.6888 81.3219 53.1789 82.0454 53.1789C82.1637 53.1789 82.2828 53.1928 82.401 53.2198C82.5193 53.2468 82.6454 53.2842 82.7787 53.3294C82.9119 53.3755 82.9966 53.4016 83.0319 53.4069V56.2905L83.0328 56.2913Z" fill="white"/>
          <path d="M66.4229 51.6413H67.7031V50.7085L66.4229 51.0914V51.6413Z" fill="white"/>
          <path d="M125.171 53.9029C125.539 53.8419 125.839 53.6879 126.074 53.4408C126.308 53.1937 126.425 52.8813 126.425 52.5028C126.425 51.9903 126.225 51.6031 125.825 51.3403C125.425 51.0784 124.863 50.947 124.14 50.947H121.818V57.1719H124.263C125.805 57.1719 126.575 56.6072 126.575 55.4787C126.575 55.021 126.452 54.6581 126.206 54.3893C125.96 54.1213 125.615 53.9594 125.17 53.9046L125.171 53.9029ZM123.108 51.7876H124.051C124.768 51.7876 125.126 52.0747 125.126 52.6481C125.126 52.9292 125.03 53.1424 124.837 53.2885C124.645 53.4347 124.39 53.5078 124.076 53.5078H123.107V51.7867L123.108 51.7876ZM124.077 56.3279H123.107V54.3327H124.059C124.841 54.3327 125.232 54.6686 125.232 55.3394C125.232 55.999 124.847 56.3279 124.076 56.3279H124.077Z" fill="white"/>
          <path d="M129.671 52.374C128.977 52.374 128.432 52.5768 128.035 52.9831C127.638 53.3895 127.439 53.9646 127.439 54.7086C127.439 55.5874 127.609 56.2357 127.946 56.6542C128.284 57.0719 128.877 57.2816 129.725 57.2816C130.152 57.2816 130.547 57.2407 130.912 57.158C131.276 57.0753 131.518 56.9979 131.636 56.9248V56.1008C131.523 56.1861 131.322 56.2766 131.032 56.3705C130.741 56.4654 130.45 56.5124 130.16 56.5124C129.644 56.5124 129.272 56.3932 129.044 56.1556C128.815 55.9172 128.695 55.5517 128.684 55.0575H131.867V54.7095C131.867 53.9777 131.673 53.4051 131.285 52.9927C130.897 52.5811 130.358 52.374 129.671 52.374ZM128.684 54.3788C128.702 53.5304 129.031 53.1067 129.672 53.1067C129.986 53.1067 130.228 53.2215 130.396 53.4504C130.566 53.6792 130.656 53.989 130.667 54.3797L128.684 54.3788Z" fill="white"/>
          <path d="M141.72 52.9274C141.323 52.5585 140.721 52.374 139.915 52.374C138.314 52.374 137.514 53.1519 137.514 54.7086C137.514 55.6118 137.688 56.2661 138.039 56.6725C138.388 57.0788 139.014 57.2816 139.915 57.2816C140.733 57.2816 141.338 57.0893 141.73 56.7047C142.12 56.3201 142.316 55.6553 142.316 54.7095C142.316 53.8915 142.118 53.2981 141.721 52.9292L141.72 52.9274ZM140.755 56.0764C140.58 56.3479 140.299 56.4836 139.915 56.4836C139.518 56.4836 139.233 56.3505 139.06 56.0851C138.888 55.8197 138.803 55.3603 138.803 54.7077C138.803 54.1708 138.888 53.7819 139.06 53.5409C139.233 53.2998 139.517 53.1798 139.915 53.1798C140.305 53.1798 140.587 53.299 140.759 53.5365C140.931 53.7749 141.017 54.1647 141.017 54.7086C141.017 55.349 140.929 55.8049 140.755 56.0764Z" fill="white"/>
          <path d="M132.837 57.1701H134.082V50.5519L132.837 50.9243V57.1701Z" fill="white"/>
          <path d="M135.273 57.1701H136.518V50.5519L135.273 50.9243V57.1701Z" fill="white"/>
          <path d="M89.9583 50.946L87.958 57.171H89.2745L89.7474 55.4638H91.7415L92.2092 57.171H93.5962L91.6136 50.946H89.9583ZM89.9812 54.6154L90.7498 51.8432L91.5086 54.6154H89.9812Z" fill="white"/>
          <path d="M98.1435 52.7586C97.7729 52.5019 97.2409 52.374 96.5474 52.374C95.7947 52.374 95.0447 52.5019 94.2974 52.7586V57.1711H95.5424V53.3816C95.6191 53.339 95.7585 53.2981 95.9606 53.2581C96.1618 53.218 96.3488 53.1989 96.5209 53.1989C96.8465 53.1989 97.0821 53.2894 97.2277 53.4686C97.3732 53.6488 97.4456 53.9429 97.4456 54.3518V57.1711H98.6994V53.9124C98.6994 53.3999 98.5141 53.0153 98.1435 52.7586Z" fill="white"/>
          <path d="M106.404 52.5115C105.968 52.6029 105.667 52.682 105.501 52.7499V57.1711H106.746V53.3721C106.753 53.3721 106.805 53.3599 106.902 53.3355C107 53.3112 107.09 53.2894 107.173 53.2711C107.256 53.2529 107.361 53.2346 107.489 53.2163C107.616 53.198 107.733 53.1885 107.84 53.1885C108.006 53.1885 108.169 53.2067 108.329 53.2433V52.4288C108.222 52.3923 107.999 52.374 107.661 52.374C107.258 52.374 106.839 52.4201 106.403 52.5115H106.404Z" fill="white"/>
          <path d="M112.313 50.5519H111.238L110.473 51.8153H111.371L112.313 50.5519Z" fill="white"/>
          <path d="M111.016 52.374C110.322 52.374 109.777 52.5768 109.379 52.9831C108.982 53.3895 108.783 53.9646 108.783 54.7086C108.783 55.5874 108.952 56.2357 109.29 56.6542C109.628 57.0719 110.221 57.2816 111.068 57.2816C111.496 57.2816 111.891 57.2407 112.255 57.158C112.62 57.0753 112.861 56.9979 112.98 56.9248V56.1008C112.867 56.1861 112.666 56.2766 112.375 56.3705C112.085 56.4654 111.794 56.5124 111.503 56.5124C110.987 56.5124 110.616 56.3932 110.387 56.1556C110.159 55.9172 110.039 55.5517 110.027 55.0575H113.211V54.7095C113.211 53.9777 113.017 53.4051 112.628 52.9927C112.24 52.5811 111.702 52.3749 111.015 52.3749L111.016 52.374ZM110.028 54.3788C110.046 53.5304 110.375 53.1067 111.016 53.1067C111.33 53.1067 111.571 53.2215 111.74 53.4504C111.908 53.6792 111.999 53.989 112.011 54.3797H110.027L110.028 54.3788Z" fill="white"/>
          <path d="M117.458 54.9601C117.176 54.7373 116.867 54.5772 116.533 54.4798C116.198 54.3823 115.89 54.2648 115.608 54.1274C115.327 53.9899 115.185 53.8393 115.185 53.674C115.185 53.326 115.547 53.1519 116.271 53.1519C116.715 53.1519 117.189 53.2772 117.694 53.527V52.7212C117.214 52.4889 116.615 52.3732 115.898 52.3732C115.316 52.3732 114.842 52.4985 114.474 52.7482C114.107 52.9988 113.923 53.3434 113.923 53.7828C113.923 54.0569 114.015 54.2953 114.199 54.4972C114.383 54.6982 114.605 54.8522 114.866 54.9592C115.127 55.0662 115.388 55.1619 115.649 55.2472C115.91 55.3325 116.132 55.4317 116.316 55.5448C116.499 55.6579 116.592 55.7902 116.592 55.9433C116.592 56.1078 116.494 56.2444 116.298 56.3505C116.102 56.4576 115.818 56.5106 115.445 56.5106C114.965 56.5106 114.464 56.3766 113.942 56.1078V56.9222C114.061 56.9953 114.297 57.0736 114.649 57.1554C115.002 57.2381 115.397 57.279 115.836 57.279C116.505 57.279 117.014 57.145 117.36 56.8761C117.707 56.6072 117.881 56.2357 117.881 55.7588C117.881 55.4473 117.74 55.1811 117.458 54.9583L117.458 54.9601Z" fill="white"/>
          <path d="M103.065 52.6481C102.709 52.4653 102.252 52.3731 101.696 52.3731C101.109 52.3731 100.629 52.575 100.255 52.977C99.8814 53.3798 99.6943 53.9567 99.6943 54.7068C99.6943 55.6161 99.8814 56.2721 100.255 56.675C100.628 57.0779 101.23 57.2789 102.06 57.2789C102.866 57.2789 103.619 57.1475 104.319 56.8847V50.5502L103.065 50.9252V52.6463V52.6481ZM103.065 56.2913C102.775 56.4192 102.443 56.4836 102.069 56.4836C101.695 56.4836 101.423 56.3418 101.251 56.0581C101.079 55.7744 100.993 55.3246 100.993 54.7077C100.993 53.6887 101.355 53.1788 102.078 53.1788C102.197 53.1788 102.316 53.1928 102.434 53.2197C102.552 53.2476 102.678 53.2841 102.812 53.3294C102.945 53.3755 103.03 53.4007 103.065 53.4068V56.2913Z" fill="white"/>
          <path d="M165 10.1561V56.8439" stroke="white" stroke-width="2.31502" stroke-linecap="round"/>
          <path d="M190.816 47.1895C189.458 47.1895 188.087 47.1401 186.704 47.0413C185.321 46.9673 184.111 46.7944 183.074 46.5228V21.5947C183.618 21.4959 184.198 21.4095 184.815 21.3354C185.433 21.2366 186.062 21.1626 186.704 21.1132C187.346 21.0638 187.976 21.0267 188.593 21.0021C189.235 20.9774 189.84 20.965 190.408 20.965C191.964 20.965 193.409 21.0885 194.742 21.3354C196.075 21.5577 197.224 21.9404 198.187 22.4837C199.175 23.0269 199.94 23.743 200.483 24.632C201.027 25.521 201.298 26.6198 201.298 27.9286C201.298 29.1386 201.002 30.1757 200.409 31.04C199.841 31.9042 199.039 32.5957 198.002 33.1142C199.557 33.6328 200.706 34.3983 201.446 35.4107C202.187 36.4231 202.558 37.7072 202.558 39.2629C202.558 41.9051 201.594 43.8929 199.668 45.2264C197.742 46.5351 194.791 47.1895 190.816 47.1895ZM187.667 35.3366V43.1521C188.186 43.2015 188.741 43.2386 189.334 43.2632C189.927 43.2879 190.47 43.3003 190.964 43.3003C191.927 43.3003 192.816 43.2386 193.631 43.1151C194.47 42.9916 195.187 42.7817 195.779 42.4854C196.396 42.1644 196.878 41.7446 197.224 41.226C197.594 40.7075 197.779 40.0407 197.779 39.2259C197.779 37.7689 197.248 36.7565 196.187 36.1886C195.125 35.6206 193.656 35.3366 191.779 35.3366H187.667ZM187.667 31.6696H190.964C192.742 31.6696 194.137 31.4227 195.149 30.9288C196.162 30.4103 196.668 29.4966 196.668 28.1879C196.668 26.9532 196.137 26.0766 195.075 25.558C194.038 25.0394 192.68 24.7802 191.001 24.7802C190.285 24.7802 189.643 24.7925 189.075 24.8172C188.532 24.8419 188.062 24.8789 187.667 24.9283V31.6696ZM211.715 46.8932H207.233V27.5211H211.715V46.8932ZM212.196 21.854C212.196 22.6936 211.925 23.3603 211.381 23.8542C210.838 24.348 210.196 24.595 209.455 24.595C208.69 24.595 208.036 24.348 207.492 23.8542C206.949 23.3603 206.677 22.6936 206.677 21.854C206.677 20.9897 206.949 20.3106 207.492 19.8168C208.036 19.3229 208.69 19.076 209.455 19.076C210.196 19.076 210.838 19.3229 211.381 19.8168C211.925 20.3106 212.196 20.9897 212.196 21.854ZM230.286 37.1516C230.286 35.2502 229.903 33.7439 229.137 32.6327C228.397 31.5215 227.211 30.9659 225.581 30.9659C224.841 30.9659 224.137 31.077 223.47 31.2992C222.828 31.5215 222.31 31.7684 221.915 32.04V43.1892C222.236 43.2632 222.643 43.3373 223.137 43.4114C223.655 43.4608 224.273 43.4855 224.989 43.4855C226.643 43.4855 227.94 42.9299 228.878 41.8187C229.816 40.6828 230.286 39.1271 230.286 37.1516ZM234.879 37.2257C234.879 38.7814 234.644 40.1889 234.175 41.4483C233.73 42.6829 233.076 43.7448 232.212 44.6337C231.372 45.5227 230.347 46.2018 229.137 46.6709C227.927 47.1401 226.557 47.3747 225.026 47.3747C223.544 47.3747 222.124 47.2636 220.766 47.0413C219.433 46.8191 218.322 46.5722 217.433 46.3005V18.8908L221.915 18.15V28.1879C222.433 27.9162 223.063 27.6693 223.804 27.4471C224.569 27.2248 225.409 27.1137 226.322 27.1137C227.68 27.1137 228.89 27.3606 229.952 27.8545C231.039 28.3237 231.94 29.0027 232.656 29.8917C233.372 30.7807 233.916 31.8548 234.286 33.1142C234.681 34.3489 234.879 35.7194 234.879 37.2257ZM246.239 47.2636C244.906 47.2389 243.794 47.0907 242.905 46.8191C242.041 46.5475 241.35 46.1647 240.831 45.6709C240.313 45.1523 239.942 44.5226 239.72 43.7818C239.522 43.0163 239.424 42.152 239.424 41.189V18.8908L243.905 18.15V40.3371C243.905 40.8803 243.942 41.3372 244.017 41.7076C244.115 42.078 244.276 42.399 244.498 42.6706C244.72 42.9175 245.017 43.1151 245.387 43.2632C245.782 43.3867 246.276 43.4855 246.869 43.5596L246.239 47.2636ZM255.013 46.8932H250.531V27.5211H255.013V46.8932ZM255.494 21.854C255.494 22.6936 255.223 23.3603 254.68 23.8542C254.136 24.348 253.494 24.595 252.753 24.595C251.988 24.595 251.334 24.348 250.79 23.8542C250.247 23.3603 249.975 22.6936 249.975 21.854C249.975 20.9897 250.247 20.3106 250.79 19.8168C251.334 19.3229 251.988 19.076 252.753 19.076C253.494 19.076 254.136 19.3229 254.68 19.8168C255.223 20.3106 255.494 20.9897 255.494 21.854ZM278.251 37.1886C278.251 38.7196 278.028 40.1148 277.584 41.3742C277.139 42.6336 276.51 43.7077 275.695 44.5967C274.88 45.4857 273.892 46.1771 272.732 46.6709C271.596 47.1648 270.336 47.4118 268.954 47.4118C267.571 47.4118 266.311 47.1648 265.176 46.6709C264.04 46.1771 263.064 45.4857 262.249 44.5967C261.434 43.7077 260.792 42.6336 260.323 41.3742C259.879 40.1148 259.657 38.7196 259.657 37.1886C259.657 35.6576 259.879 34.2748 260.323 33.0401C260.792 31.7808 261.434 30.7066 262.249 29.8176C263.089 28.9287 264.077 28.2496 265.213 27.7804C266.348 27.2865 267.595 27.0396 268.954 27.0396C270.312 27.0396 271.559 27.2865 272.695 27.7804C273.855 28.2496 274.843 28.9287 275.658 29.8176C276.473 30.7066 277.102 31.7808 277.547 33.0401C278.016 34.2748 278.251 35.6576 278.251 37.1886ZM273.658 37.1886C273.658 35.2625 273.238 33.7439 272.398 32.6327C271.583 31.4968 270.435 30.9288 268.954 30.9288C267.472 30.9288 266.311 31.4968 265.472 32.6327C264.657 33.7439 264.249 35.2625 264.249 37.1886C264.249 39.1394 264.657 40.6828 265.472 41.8187C266.311 42.9546 267.472 43.5225 268.954 43.5225C270.435 43.5225 271.583 42.9546 272.398 41.8187C273.238 40.6828 273.658 39.1394 273.658 37.1886ZM282.646 22.4096L287.128 21.6688V27.5211H294.017V31.2622H287.128V39.1518C287.128 40.7075 287.375 41.8187 287.868 42.4854C288.362 43.1521 289.202 43.4855 290.387 43.4855C291.202 43.4855 291.918 43.3991 292.536 43.2262C293.178 43.0533 293.684 42.8928 294.054 42.7447L294.795 46.3005C294.276 46.5228 293.597 46.745 292.758 46.9673C291.918 47.2142 290.93 47.3377 289.795 47.3377C288.412 47.3377 287.251 47.1525 286.313 46.7821C285.399 46.4117 284.671 45.8808 284.127 45.1893C283.584 44.4732 283.201 43.6213 282.979 42.6336C282.757 41.6211 282.646 40.4729 282.646 39.1888V22.4096ZM296.95 37.2998C296.95 35.5959 297.197 34.102 297.691 32.8179C298.209 31.5338 298.888 30.472 299.728 29.6324C300.568 28.7682 301.531 28.1261 302.617 27.7063C303.704 27.2619 304.815 27.0396 305.951 27.0396C308.618 27.0396 310.692 27.8668 312.174 29.5213C313.68 31.1758 314.433 33.6451 314.433 36.9294C314.433 37.1763 314.421 37.4603 314.396 37.7813C314.396 38.0776 314.384 38.3492 314.359 38.5962H301.58C301.703 40.1519 302.247 41.3618 303.21 42.2261C304.198 43.0657 305.617 43.4855 307.469 43.4855C308.556 43.4855 309.544 43.3867 310.433 43.1892C311.346 42.9916 312.062 42.7817 312.581 42.5595L313.174 46.2265C312.927 46.3499 312.581 46.4857 312.136 46.6339C311.717 46.7574 311.223 46.8685 310.655 46.9673C310.112 47.0907 309.519 47.1895 308.877 47.2636C308.235 47.3377 307.581 47.3747 306.914 47.3747C305.21 47.3747 303.728 47.1278 302.469 46.6339C301.21 46.1153 300.172 45.4116 299.358 44.5226C298.543 43.609 297.938 42.5471 297.543 41.3372C297.148 40.1025 296.95 38.7567 296.95 37.2998ZM309.951 35.2996C309.951 34.6823 309.865 34.102 309.692 33.5587C309.519 32.9907 309.26 32.5092 308.914 32.1141C308.593 31.6943 308.186 31.3733 307.692 31.1511C307.222 30.9041 306.655 30.7807 305.988 30.7807C305.296 30.7807 304.691 30.9165 304.173 31.1881C303.654 31.4351 303.21 31.7684 302.839 32.1882C302.494 32.608 302.222 33.0895 302.024 33.6328C301.827 34.176 301.691 34.7316 301.617 35.2996H309.951ZM318.111 37.2257C318.111 35.7935 318.333 34.46 318.777 33.2253C319.222 31.966 319.852 30.8795 320.666 29.9658C321.506 29.0521 322.518 28.336 323.704 27.8175C324.889 27.2989 326.222 27.0396 327.704 27.0396C329.531 27.0396 331.26 27.373 332.89 28.0397L331.927 31.7067C331.408 31.4844 330.815 31.2992 330.149 31.1511C329.507 31.0029 328.815 30.9288 328.074 30.9288C326.321 30.9288 324.988 31.4844 324.074 32.5957C323.16 33.6822 322.704 35.2255 322.704 37.2257C322.704 39.1518 323.136 40.6828 324 41.8187C324.864 42.9299 326.321 43.4855 328.371 43.4855C329.136 43.4855 329.889 43.4114 330.63 43.2632C331.371 43.1151 332.013 42.9299 332.556 42.7076L333.186 46.4117C332.692 46.6586 331.939 46.8808 330.927 47.0784C329.939 47.2759 328.914 47.3747 327.852 47.3747C326.198 47.3747 324.753 47.1278 323.519 46.6339C322.309 46.1153 321.296 45.4116 320.481 44.5226C319.691 43.609 319.098 42.5348 318.703 41.3001C318.308 40.0407 318.111 38.6826 318.111 37.2257ZM343.471 43.7448C344.854 43.7448 345.904 43.6707 346.62 43.5225V38.5591C346.373 38.4851 346.015 38.411 345.546 38.3369C345.076 38.2628 344.558 38.2258 343.99 38.2258C343.496 38.2258 342.99 38.2628 342.471 38.3369C341.977 38.411 341.521 38.5468 341.101 38.7443C340.706 38.9419 340.385 39.2259 340.138 39.5963C339.891 39.942 339.767 40.3865 339.767 40.9297C339.767 41.9915 340.101 42.7323 340.767 43.1521C341.434 43.5472 342.335 43.7448 343.471 43.7448ZM343.101 27.0396C344.583 27.0396 345.83 27.2248 346.842 27.5952C347.854 27.9656 348.657 28.4842 349.25 29.1509C349.867 29.8176 350.299 30.6325 350.546 31.5956C350.818 32.5339 350.953 33.571 350.953 34.7069V46.4487C350.262 46.5969 349.213 46.7697 347.805 46.9673C346.422 47.1895 344.854 47.3006 343.101 47.3006C341.94 47.3006 340.879 47.1895 339.915 46.9673C338.952 46.745 338.125 46.387 337.434 45.8931C336.767 45.3992 336.236 44.7572 335.841 43.967C335.471 43.1768 335.285 42.2014 335.285 41.0408C335.285 39.9296 335.495 38.9913 335.915 38.2258C336.36 37.4603 336.952 36.8429 337.693 36.3738C338.434 35.8799 339.286 35.5342 340.249 35.3366C341.237 35.1144 342.261 35.0033 343.323 35.0033C343.817 35.0033 344.336 35.0403 344.879 35.1144C345.422 35.1638 346.002 35.2625 346.62 35.4107V34.6699C346.62 34.1513 346.558 33.6575 346.435 33.1883C346.311 32.7191 346.089 32.3117 345.768 31.966C345.472 31.5956 345.064 31.3116 344.546 31.114C344.052 30.9165 343.422 30.8177 342.656 30.8177C341.619 30.8177 340.669 30.8918 339.804 31.04C338.94 31.1881 338.236 31.361 337.693 31.5585L337.137 27.9286C337.705 27.731 338.533 27.5335 339.619 27.3359C340.706 27.1384 341.866 27.0396 343.101 27.0396ZM361.294 43.6707C362.48 43.6707 363.344 43.5349 363.887 43.2632C364.43 42.9669 364.702 42.4731 364.702 41.7816C364.702 41.1396 364.406 40.6087 363.813 40.1889C363.245 39.7691 362.294 39.3123 360.961 38.8184C360.146 38.5221 359.393 38.2134 358.702 37.8924C358.035 37.5467 357.455 37.1516 356.961 36.7071C356.467 36.2626 356.072 35.7317 355.775 35.1144C355.504 34.4724 355.368 33.6945 355.368 32.7809C355.368 31.0029 356.022 29.6077 357.331 28.5953C358.64 27.5582 360.418 27.0396 362.665 27.0396C363.801 27.0396 364.887 27.1507 365.924 27.373C366.962 27.5705 367.739 27.7681 368.258 27.9656L367.443 31.5956C366.949 31.3733 366.319 31.1758 365.554 31.0029C364.788 30.8054 363.9 30.7066 362.887 30.7066C361.973 30.7066 361.233 30.8671 360.665 31.1881C360.097 31.4844 359.813 31.9536 359.813 32.5957C359.813 32.9167 359.862 33.2006 359.961 33.4476C360.084 33.6945 360.282 33.9291 360.554 34.1513C360.825 34.3489 361.183 34.5588 361.628 34.781C362.072 34.9786 362.615 35.1885 363.258 35.4107C364.319 35.8058 365.221 36.2009 365.961 36.596C366.702 36.9664 367.307 37.3985 367.776 37.8924C368.27 38.3616 368.628 38.9048 368.851 39.5222C369.073 40.1395 369.184 40.8803 369.184 41.7446C369.184 43.5966 368.493 45.0041 367.11 45.9672C365.752 46.9055 363.801 47.3747 361.257 47.3747C359.553 47.3747 358.183 47.2266 357.146 46.9302C356.109 46.6586 355.38 46.4364 354.96 46.2635L355.738 42.5224C356.405 42.7941 357.195 43.0533 358.109 43.3003C359.047 43.5472 360.109 43.6707 361.294 43.6707Z" fill="white"/>
        </svg>
      </div>
      <div class="header-right">
        <button class="mobile-menu-btn" @click="toggleMobileMenu" aria-label="Abrir menú">
          <svg class="menu-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <path d="M3 6H21" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <path d="M3 18H21" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <nav class="nav">
          <div 
            class="nav-link-wrapper"
            @mouseenter="showServiciosDropdownHover"
            @mouseleave="hideServiciosDropdown"
          >
          <span 
            class="nav-link"
          >
            Servicios
            <svg class="dropdown-icon" :class="{ rotated: showServiciosDropdown }" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.29369 6.28738C5.90247 6.28738 5.51124 6.14224 5.17681 5.84567L0.19186 1.06896C-0.0542323 0.829176 -0.0668524 0.437952 0.17293 0.19186C0.412712 -0.0542327 0.803936 -0.0668521 1.05003 0.17293L6.01605 4.93071C6.19904 5.09477 6.39465 5.09477 6.60288 4.91178L11.55 0.17293C11.7961 -0.0668521 12.1936 -0.0542327 12.4271 0.19186C12.6669 0.437952 12.6542 0.835486 12.4081 1.06896L7.44212 5.82674C7.09507 6.13593 6.69122 6.28738 6.29369 6.28738Z" fill="white"/>
            </svg>
          </span>
            <div 
              class="dropdown-menu dropdown-servicios"
              :class="{ active: showServiciosDropdown }"
            >
              <a 
                href="https://bibliografiadigital.aiep.cl/?_gl=1*8rbnmu*_gcl_au*OTUzMjQzNjY5LjE3NjU0NjcxNzM.*_ga*MTc5NjU2OTU3MS4xNzY1NDY3MTcy*_ga_LXQ40Q3QZJ*czE3NjU5ODY1MDIkbzckZzEkdDE3NjU5ODcwMjckajYwJGwwJGgxMDI4OTA1Mw.." 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Bibliografía básica digital
              </a>
              <a 
                href="http://biblioteayuda.aiep.cl/referencia/index.php?_gl=1*8rbnmu*_gcl_au*OTUzMjQzNjY5LjE3NjU0NjcxNzM.*_ga*MTc5NjU2OTU3MS4xNzY1NDY3MTcy*_ga_LXQ40Q3QZJ*czE3NjU5ODY1MDIkbzckZzEkdDE3NjU5ODcwMjckajYwJGwwJGgxMDI4OTA1Mw.." 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Bibliotecario en línea
              </a>
              <a 
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=jfEJ3MNq8E6gHmZSXtmk0IQ7mA6rH_1GodIbSTop2-1UMFRXSkFEVDdMVE04QTM5MFlBT0E3VkVCQy4u" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Taller de biblioteca para docentes
              </a>
              <a 
                href="https://forms.office.com/Pages/ResponsePage.aspx?id=jfEJ3MNq8E6gHmZSXtmk0IQ7mA6rH_1GodIbSTop2-1UMktRVEtTSVlLSTA3TkZTRjBMTUFRQUM5My4u" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Taller de biblioteca para estudiantes
              </a>
              <a 
                href="#servicios-presenciales" 
                class="dropdown-item"
                @click.prevent="scrollToServiciosPresenciales"
              >
                Notebooks, salas y más
              </a>
            </div>
          </div>
          <div 
            class="nav-link-wrapper"
            @mouseenter="showBibliografiaDropdownHover"
            @mouseleave="hideBibliografiaDropdown"
          >
          <span 
            :class="['nav-link', { active: isInBibliografia }]"
          >
            Bibliografía por escuelas
            <svg class="dropdown-icon" :class="{ rotated: showBibliografiaDropdown }" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.29369 6.28738C5.90247 6.28738 5.51124 6.14224 5.17681 5.84567L0.19186 1.06896C-0.0542323 0.829176 -0.0668524 0.437952 0.17293 0.19186C0.412712 -0.0542327 0.803936 -0.0668521 1.05003 0.17293L6.01605 4.93071C6.19904 5.09477 6.39465 5.09477 6.60288 4.91178L11.55 0.17293C11.7961 -0.0668521 12.1936 -0.0542327 12.4271 0.19186C12.6669 0.437952 12.6542 0.835486 12.4081 1.06896L7.44212 5.82674C7.09507 6.13593 6.69122 6.28738 6.29369 6.28738Z" fill="white"/>
            </svg>
          </span>
            <div 
              class="dropdown-menu dropdown-escuelas"
              :class="{ active: showBibliografiaDropdown }"
            >
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('administracion')">Administración y Gestión Empresarial</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('artes')">Artes e Industrias Creativas</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('desarrollo')">Desarrollo Social y Educación</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('estetica')">Estética Integral</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('gastronomia')">Gastronomía, Hotelería y Turismo</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('ingenieria')">Ingeniería, Energía y Tecnología</a>
              <a href="#" class="dropdown-item" @click.prevent="navigateToSchoolFromDropdown('salud')">Salud y Deporte</a>
            </div>
          </div>
          <div 
            class="nav-link-wrapper"
            @mouseenter="showBibliotecasDropdownHover"
            @mouseleave="hideBibliotecasDropdown"
          >
          <span 
            :class="['nav-link', { active: isInBibliotecas }]"
          >
            Encuentra tu biblioteca
            <svg class="dropdown-icon" :class="{ rotated: showBibliotecasDropdown }" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.29369 6.28738C5.90247 6.28738 5.51124 6.14224 5.17681 5.84567L0.19186 1.06896C-0.0542323 0.829176 -0.0668524 0.437952 0.17293 0.19186C0.412712 -0.0542327 0.803936 -0.0668521 1.05003 0.17293L6.01605 4.93071C6.19904 5.09477 6.39465 5.09477 6.60288 4.91178L11.55 0.17293C11.7961 -0.0668521 12.1936 -0.0542327 12.4271 0.19186C12.6669 0.437952 12.6542 0.835486 12.4081 1.06896L7.44212 5.82674C7.09507 6.13593 6.69122 6.28738 6.29369 6.28738Z" fill="white"/>
            </svg>
          </span>
            <div 
              class="dropdown-menu dropdown-bibliotecas"
              :class="{ active: showBibliotecasDropdown }"
            >
              <a 
                v-for="region in regions" 
                :key="region.id"
                href="#" 
                class="dropdown-item"
                @click.prevent="navigateToRegionFromDropdown(region)"
              >
                {{ region.name }}
              </a>
            </div>
          </div>
          <div 
            class="nav-link-wrapper"
            @mouseenter="showRecursosDropdownHover"
            @mouseleave="hideRecursosDropdown"
          >
          <span 
            :class="['nav-link', { active: isInRecursos }]"
          >
            Recursos de información
            <svg class="dropdown-icon" :class="{ rotated: showRecursosDropdown }" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.29369 6.28738C5.90247 6.28738 5.51124 6.14224 5.17681 5.84567L0.19186 1.06896C-0.0542323 0.829176 -0.0668524 0.437952 0.17293 0.19186C0.412712 -0.0542327 0.803936 -0.0668521 1.05003 0.17293L6.01605 4.93071C6.19904 5.09477 6.39465 5.09477 6.60288 4.91178L11.55 0.17293C11.7961 -0.0668521 12.1936 -0.0542327 12.4271 0.19186C12.6669 0.437952 12.6542 0.835486 12.4081 1.06896L7.44212 5.82674C7.09507 6.13593 6.69122 6.28738 6.29369 6.28738Z" fill="white"/>
            </svg>
          </span>
            <div 
              class="dropdown-menu dropdown-recursos"
              :class="{ active: showRecursosDropdown }"
            >
              <a 
                href="https://itmsp.museknowledge.com/MuseSessionID=0910qnxid/MuseProtocol=https/MuseHost=www.proquest.com/MusePath/index?parentSessionId=Qru4aIKBNrLQJ%2FvHVgOHse7XO26dC1QXWOcVe1ik2RQ%3D&accountid=163619" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Revistas Académicas (Proquest)
              </a>
              <a 
                href="https://revistaschilenas.uchile.cl/" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Portal de Revistas Académicas Chilenas
              </a>
              <a 
                href="https://www.leychile.cl/Consulta/homebasico" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Biblioteca del Congreso
              </a>
              <a 
                href="https://www.inncoleccion.cl/colecao.aspx" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Normas Chilenas
              </a>
              <a 
                href="http://www.diariooficial.interior.gob.cl/" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Diario Oficial de la República
              </a>
              <a 
                href="https://09115nxig-y-https-next--proview-thomsonreuters-com.itmsp.museknowledge.com/library" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Biblioteca Thomson-Reuters
              </a>
              <a 
                href="https://0910cnxik-y-https-www-eni--training-com.itmsp.museknowledge.com/instant-Connection/Default.aspx" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Biblioteca ENI
              </a>
              <a 
                href="http://www.insht.es/portal/site/Insht/menuitem.1f1a3bc79ab34c578c2e8884060961ca/?vgnextoid=a981ceffc39a5110VgnVCM100000dc0ca8c0RCRD&vgnextchannel=9f164a7f8a651110VgnVCM100000dc0ca8c0RCRD" 
                class="dropdown-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Enciclopedia OIT
              </a>
              <a 
                href="#sitios-recomendados" 
                class="dropdown-item"
                @click.prevent="scrollToSitiosRecomendados"
              >
                Ver todos los recursos
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <!-- Menú lateral móvil -->
    <div class="mobile-menu-overlay" :class="{ active: isMobileMenuOpen }" @click="closeMobileMenu">
      <div class="mobile-menu" :class="{ active: isMobileMenuOpen }" @click.stop>
        <div class="mobile-menu-header">
          <p class="welcome-text">¡Hola! ¿Qué te gustaría hacer?</p>
          <a href="https://atl-sdcas01.sirsidynix.net/aiep_cas_saml/login?service=https://bibliotecas.aiep.cl/client/en_US/default/search/casrequest" target="_blank" rel="noopener noreferrer" class="login-button">Iniciar sesión</a>
        </div>
        <div class="mobile-menu-content">
          <div class="menu-section">
            <div class="menu-section-header" @click="toggleSection('servicios')">
              <span>Servicios</span>
              <svg class="chevron-icon" :class="{ rotated: expandedSections.servicios }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="menu-section-content" v-if="expandedSections.servicios">
              <div class="menu-item" @click="navigateToServicio('bibliografia-digital')">
                Bibliografía básica digital
              </div>
              <div class="menu-item" @click="navigateToServicio('bibliotecario-linea')">
                Bibliotecario en línea
              </div>
              <div class="menu-item" @click="navigateToServicio('taller-docentes')">
                Taller de biblioteca para docentes
              </div>
              <div class="menu-item" @click="navigateToServicio('taller-estudiantes')">
                Taller de biblioteca para estudiantes
              </div>
              <div class="menu-item" @click="scrollToServiciosPresenciales">
                Notebooks, salas y más
              </div>
            </div>
          </div>
          <div class="menu-section">
            <div class="menu-section-header active" @click="toggleSection('bibliografia')">
              <span>Bibliografía por escuelas</span>
              <svg class="chevron-icon" :class="{ rotated: expandedSections.bibliografia }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="menu-section-content" v-if="expandedSections.bibliografia">
              <div class="menu-item" v-for="school in schools" :key="school.id" @click="navigateToSchool(school)">
                {{ school.name }}
              </div>
            </div>
          </div>
          <div class="menu-section">
            <div class="menu-section-header" @click="toggleSection('bibliotecas')">
              <span>Encuentra tu biblioteca</span>
              <svg class="chevron-icon" :class="{ rotated: expandedSections.bibliotecas }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
            </div>
            <div class="menu-section-content" v-if="expandedSections.bibliotecas">
              <div 
                v-for="region in regions" 
                :key="region.id"
                class="menu-subsection"
              >
                <div 
                  class="menu-subsection-header" 
                  @click="toggleSubsection(region.id)"
                >
                  <span>{{ region.name }}</span>
                  <svg class="chevron-icon" :class="{ rotated: expandedSubsections[region.id] }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
                </div>
                <div class="menu-subsection-content" v-if="expandedSubsections[region.id]">
                  <div 
                    v-for="library in getLibrariesByRegion(region.id)" 
                    :key="library.id"
                    class="menu-item"
                    @click="navigateToLibrary(library)"
                  >
                    {{ library.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="menu-section">
            <div class="menu-section-header" @click="toggleSection('recursos')">
              <span>Recursos de información</span>
              <svg class="chevron-icon" :class="{ rotated: expandedSections.recursos }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="menu-section-content" v-if="expandedSections.recursos">
              <div class="menu-item" @click="navigateToRecursos('revistas-proquest')">Revistas Académicas (Proquest)</div>
              <div class="menu-item" @click="navigateToRecursos('portal-revistas-chilenas')">Portal de Revistas Académicas Chilenas</div>
              <div class="menu-item" @click="navigateToRecursos('biblioteca-congreso')">Biblioteca del Congreso</div>
              <div class="menu-item" @click="navigateToRecursos('normas-chilenas')">Normas Chilenas</div>
              <div class="menu-item" @click="navigateToRecursos('diario-oficial')">Diario Oficial de la República</div>
              <div class="menu-item" @click="navigateToRecursos('thomson-reuters')">Biblioteca Thomson-Reuters</div>
              <div class="menu-item" @click="navigateToRecursos('biblioteca-eni')">Biblioteca ENI</div>
              <div class="menu-item" @click="navigateToRecursos('enciclopedia-oit')">Enciclopedia OIT</div>
              <div class="menu-item" @click="navigateToRecursos('todos-recursos')">Ver todos los recursos</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
// import strapiService from '../../services/strapi' // No se usa - endpoint comentado

export default {
  name: 'HeaderSection',
  data() {
    return {
      isAtTop: true,
      isInBibliografia: false,
      isInBibliotecas: false,
      isInRecursos: false,
      isMobileMenuOpen: false,
      isLibrosDigitales: false,
      showServiciosDropdown: false,
      showBibliografiaDropdown: false,
      showBibliotecasDropdown: false,
      showRecursosDropdown: false,
      serviciosTimeout: null,
      bibliografiaTimeout: null,
      bibliotecasTimeout: null,
      recursosTimeout: null,
      expandedSections: {
        servicios: false,
        bibliografia: true,
        bibliotecas: false,
        recursos: false
      },
      expandedSubsections: {
        norte: false,
        'centro-costa': false,
        metropolitana: false,
        sur: false
      },
      libraries: [],
      regions: [
        { id: 'norte', name: 'Zona Norte' },
        { id: 'centro-costa', name: 'Zona Centro' },
        { id: 'metropolitana', name: 'Región Metropolitana' },
        { id: 'sur', name: 'Zona Sur' }
      ],
      schools: [
        { id: 1, name: 'Administración y Gestión Empresarial', searchName: 'Administración y Gestión Empresarial' },
        { id: 2, name: 'Artes e Industrias Creativa', searchName: 'Artes e Industrias Creativas' },
        { id: 3, name: 'Desarrollo Social y Educación', searchName: 'Desarrollo Social y Educación' },
        { id: 4, name: 'Estética Integral', searchName: 'Estética Integral' },
        { id: 5, name: 'Gastronomía, Hotelería y Turismo', searchName: 'Gastronomía y Hotelería' },
        { id: 6, name: 'Ingeniería, Energía y Tecnología', searchName: 'Ingeniería y Tecnología' },
        { id: 7, name: 'Salud y Deporte', searchName: 'Salud y Ciencias Médicas' }
      ]
    }
  },
  async mounted() {
    this.handleScroll()
    this.checkHash()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('hashchange', this.checkHash)
    await this.loadLibraries()
    this.$nextTick(() => {
      this.checkLibrosDigitales()
      this.observeHeroSection()
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('hashchange', this.checkHash)
    document.body.style.overflow = ''
  },
  methods: {
    checkHash() {
      const hash = window.location.hash
      if (hash === '#bibliografia') {
        this.isInBibliografia = true
        this.isInBibliotecas = false
        this.isAtTop = false
      } else if (hash === '#bibliotecas') {
        this.isInBibliotecas = true
        this.isInBibliografia = false
        this.isAtTop = false
      } else if (!hash || hash === '#') {
        // Si no hay hash o es solo #, verificar por scroll
        this.handleScroll()
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY || window.pageYOffset
      const headerHeight = 80
      const threshold = 200 // Umbral para considerar que una sección está activa
      
      // Si está cerca del inicio (menos de 200px desde arriba), marcar Servicios como activo
      if (scrollPosition < 200) {
        this.isAtTop = true
        this.isInBibliografia = false
        this.isInBibliotecas = false
        return
      }
      
      this.isAtTop = false
      
      // Obtener posiciones de ambas secciones
      const bibliografiaSection = document.getElementById('bibliografia')
      const bibliotecasSection = document.getElementById('bibliotecas')
      
      let bibliografiaTop = null
      let bibliotecasTop = null
      
      if (bibliografiaSection) {
        bibliografiaTop = bibliografiaSection.getBoundingClientRect().top
      }
      if (bibliotecasSection) {
        bibliotecasTop = bibliotecasSection.getBoundingClientRect().top
      }
      
      // Determinar qué sección está activa basándose en cuál está más cerca del top del viewport
      // La sección activa es la que tiene su inicio más cerca del header
      if (bibliotecasTop !== null && bibliotecasTop <= headerHeight + threshold) {
        // Si Bibliotecas está cerca del header (dentro del umbral), activarla
        this.isInBibliotecas = true
        this.isInBibliografia = false
      } else if (bibliografiaTop !== null && bibliografiaTop <= headerHeight + threshold) {
        // Si Bibliografía está cerca del header (dentro del umbral), activarla
        this.isInBibliografia = true
        this.isInBibliotecas = false
      } else {
        // Si ninguna está cerca del header, verificar cuál está más visible
        if (bibliotecasTop !== null && bibliotecasTop < window.innerHeight && bibliotecasTop > -window.innerHeight) {
          this.isInBibliotecas = true
          this.isInBibliografia = false
        } else if (bibliografiaTop !== null && bibliografiaTop < window.innerHeight && bibliografiaTop > -window.innerHeight) {
          this.isInBibliografia = true
          this.isInBibliotecas = false
        } else {
          // Si ninguna está visible, mantener estados actuales
        }
      }
    },
    scrollToSection(hash, e) {
      if (e && e.preventDefault) {
      e.preventDefault()
      }
      const section = document.querySelector(hash)
      if (section) {
        const headerHeight = 80
        const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - headerHeight
        
        // Actualizar el estado inmediatamente basado en el hash
        if (hash === '#bibliografia') {
          this.isInBibliografia = true
          this.isInBibliotecas = false
          this.isAtTop = false
        } else if (hash === '#bibliotecas') {
          this.isInBibliotecas = true
          this.isInBibliografia = false
          this.isAtTop = false
        }
        
        window.scrollTo({
          top: sectionPosition,
          behavior: 'smooth'
        })
        // Actualizar el estado después de un pequeño delay para que la detección automática funcione
        setTimeout(() => {
          this.handleScroll()
        }, 500)
      }
    },
    scrollToTop(e) {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.isAtTop = true
    },
    navigateToHome() {
      // Limpiar cualquier vista detallada abierta
      sessionStorage.removeItem('bibliografiaFromHeader')
      sessionStorage.removeItem('selectedSchool')
      
      // Cerrar cualquier dropdown abierto
      this.showServiciosDropdown = false
      this.showBibliografiaDropdown = false
      this.showBibliotecasDropdown = false
      this.showRecursosDropdown = false
      
      // Cerrar menú móvil si está abierto
      this.closeMobileMenu()
      
      // Limpiar el hash para volver al home
      window.location.hash = ''
      
      // Hacer scroll al inicio
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      
      // Resetear estados
      this.isAtTop = true
      this.isInBibliografia = false
      this.isInBibliotecas = false
      
      // Notificar a BibliografiaSection que cierre la vista detallada si está abierta
      window.dispatchEvent(new CustomEvent('bibliografia-detailed-view-changed', {
        detail: { show: false }
      }))
    },
    showServiciosDropdownHover() {
      if (this.serviciosTimeout) {
        clearTimeout(this.serviciosTimeout)
        this.serviciosTimeout = null
      }
      this.showServiciosDropdown = true
    },
    hideServiciosDropdown() {
      if (this.serviciosTimeout) {
        clearTimeout(this.serviciosTimeout)
        this.serviciosTimeout = null
      }
      this.showServiciosDropdown = false
    },
    toggleBibliografiaDropdown() {
      this.showBibliografiaDropdown = !this.showBibliografiaDropdown
    },
    navigateToBibliografia() {
      // Establecer flag para mostrar vista detallada ANTES de navegar
      sessionStorage.setItem('bibliografiaFromHeader', 'true')
      this.hideBibliografiaDropdown()
      
      // Marcar como activo inmediatamente
      this.isInBibliografia = true
      this.isInBibliotecas = false
      this.isAtTop = false
      
      // Actualizar el hash primero para que el evento hashchange se dispare
      if (window.location.hash !== '#bibliografia') {
        window.location.hash = '#bibliografia'
      } else {
        // Si ya estamos en #bibliografia, forzar el evento hashchange
        window.dispatchEvent(new HashChangeEvent('hashchange'))
      }
      
      // NO hacer scroll a la sección cuando se muestra la vista detallada
      // El scroll se manejará en checkDetailedView dentro de BibliografiaSection
      // Solo hacer scroll al inicio de la página
      window.scrollTo({ top: 0, behavior: 'smooth' })
      
      // Forzar la verificación después de múltiples delays para asegurar que se detecte
      setTimeout(() => {
        // Disparar evento personalizado para que BibliografiaSection lo detecte
        window.dispatchEvent(new CustomEvent('bibliografia-navigated'))
      }, 100)
      
      setTimeout(() => {
        // Verificar nuevamente después de un delay más largo
        window.dispatchEvent(new CustomEvent('bibliografia-navigated'))
      }, 500)
    },
    navigateToSchoolFromDropdown(schoolKey) {
      // Guardar la escuela seleccionada en sessionStorage
      sessionStorage.setItem('selectedSchool', schoolKey)
      // Navegar a bibliografía
      this.navigateToBibliografia()
    },
    showBibliografiaDropdownHover() {
      if (this.bibliografiaTimeout) {
        clearTimeout(this.bibliografiaTimeout)
        this.bibliografiaTimeout = null
      }
      this.showBibliografiaDropdown = true
    },
    hideBibliografiaDropdown() {
      if (this.bibliografiaTimeout) {
        clearTimeout(this.bibliografiaTimeout)
        this.bibliografiaTimeout = null
      }
      this.showBibliografiaDropdown = false
    },
    showBibliotecasDropdownHover() {
      if (this.bibliotecasTimeout) {
        clearTimeout(this.bibliotecasTimeout)
        this.bibliotecasTimeout = null
      }
      this.showBibliotecasDropdown = true
    },
    hideBibliotecasDropdown() {
      if (this.bibliotecasTimeout) {
        clearTimeout(this.bibliotecasTimeout)
        this.bibliotecasTimeout = null
      }
      this.showBibliotecasDropdown = false
    },
    navigateToRegionFromDropdown(region) {
      this.hideBibliotecasDropdown()
      
      // Limpiar flags de bibliografía para cerrar la vista detallada
      sessionStorage.removeItem('bibliografiaFromHeader')
      sessionStorage.removeItem('selectedSchool')
      
      // Guardar la región seleccionada para que BibliotecasSection la detecte
      sessionStorage.setItem('selectedRegion', region.id)
      
      // Cambiar el hash explícitamente para que se dispare hashchange
      if (window.location.hash !== '#bibliotecas') {
        window.location.hash = '#bibliotecas'
      } else {
        // Si ya estamos en #bibliotecas, forzar el evento hashchange
        window.dispatchEvent(new HashChangeEvent('hashchange'))
      }
      
      // Esperar a que la sección esté visible antes de hacer scroll
      // Usar polling para verificar que la sección existe en el DOM
      const checkAndScroll = () => {
        const section = document.querySelector('#bibliotecas')
        if (section && section.offsetParent !== null) {
          // La sección está visible, hacer scroll
          this.scrollToSection('#bibliotecas', { preventDefault: () => {} })
          
          // Disparar evento para que BibliotecasSection seleccione la región
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('region-selected', {
              detail: { regionId: region.id }
            }))
          }, 100)
        } else {
          // La sección aún no está visible, intentar de nuevo
          setTimeout(checkAndScroll, 100)
        }
      }
      
      // Iniciar el polling después de un pequeño delay para dar tiempo a Vue
      setTimeout(checkAndScroll, 200)
    },
    showRecursosDropdownHover() {
      if (this.recursosTimeout) {
        clearTimeout(this.recursosTimeout)
        this.recursosTimeout = null
      }
      this.showRecursosDropdown = true
    },
    hideRecursosDropdown() {
      if (this.recursosTimeout) {
        clearTimeout(this.recursosTimeout)
        this.recursosTimeout = null
      }
      this.showRecursosDropdown = false
    },
    navigateToServicio(servicio) {
      this.hideServiciosDropdown()
      this.closeMobileMenu()
      
      // Mapeo de servicios a URLs
      const serviciosUrls = {
        'bibliografia-digital': 'https://bibliografiadigital.aiep.cl/?_gl=1*8rbnmu*_gcl_au*OTUzMjQzNjY5LjE3NjU0NjcxNzM.*_ga*MTc5NjU2OTU3MS4xNzY1NDY3MTcy*_ga_LXQ40Q3QZJ*czE3NjU5ODY1MDIkbzckZzEkdDE3NjU5ODcwMjckajYwJGwwJGgxMDI4OTA1Mw..',
        'bibliotecario-linea': 'http://biblioteayuda.aiep.cl/referencia/index.php?_gl=1*8rbnmu*_gcl_au*OTUzMjQzNjY5LjE3NjU0NjcxNzM.*_ga*MTc5NjU2OTU3MS4xNzY1NDY3MTcy*_ga_LXQ40Q3QZJ*czE3NjU5ODY1MDIkbzckZzEkdDE3NjU5ODcwMjckajYwJGwwJGgxMDI4OTA1Mw..',
        'taller-docentes': 'https://forms.office.com/Pages/ResponsePage.aspx?id=jfEJ3MNq8E6gHmZSXtmk0IQ7mA6rH_1GodIbSTop2-1UMFRXSkFEVDdMVE04QTM5MFlBT0E3VkVCQy4u',
        'taller-estudiantes': 'https://forms.office.com/Pages/ResponsePage.aspx?id=jfEJ3MNq8E6gHmZSXtmk0IQ7mA6rH_1GodIbSTop2-1UMktRVEtTSVlLSTA3TkZTRjBMTUFRQUM5My4u'
      }
      
      const url = serviciosUrls[servicio]
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer')
      }
    },
    navigateToRecursos(resource) {
      this.hideRecursosDropdown()
      this.closeMobileMenu()
      
      // Mapeo de recursos a URLs
      const recursosUrls = {
        'revistas-proquest': 'https://itmsp.museknowledge.com/MuseSessionID=0910qnxid/MuseProtocol=https/MuseHost=www.proquest.com/MusePath/index?parentSessionId=Qru4aIKBNrLQJ%2FvHVgOHse7XO26dC1QXWOcVe1ik2RQ%3D&accountid=163619',
        'portal-revistas-chilenas': 'https://revistaschilenas.uchile.cl/',
        'biblioteca-congreso': 'https://www.leychile.cl/Consulta/homebasico',
        'normas-chilenas': 'https://www.inncoleccion.cl/colecao.aspx',
        'diario-oficial': 'http://www.diariooficial.interior.gob.cl/',
        'thomson-reuters': 'https://09115nxig-y-https-next--proview-thomsonreuters-com.itmsp.museknowledge.com/library',
        'biblioteca-eni': 'https://0910cnxik-y-https-www-eni--training-com.itmsp.museknowledge.com/instant-Connection/Default.aspx',
        'enciclopedia-oit': 'http://www.insht.es/portal/site/Insht/menuitem.1f1a3bc79ab34c578c2e8884060961ca/?vgnextoid=a981ceffc39a5110VgnVCM100000dc0ca8c0RCRD&vgnextchannel=9f164a7f8a651110VgnVCM100000dc0ca8c0RCRD',
        'todos-recursos': null // Se maneja con scrollToSitiosRecomendados
      }
      
      if (resource === 'todos-recursos') {
        this.scrollToSitiosRecomendados()
      } else if (recursosUrls[resource]) {
        window.open(recursosUrls[resource], '_blank', 'noopener,noreferrer')
      }
    },
    scrollToServiciosPresenciales() {
      this.hideServiciosDropdown()
      this.closeMobileMenu()
      
      // Limpiar cualquier vista detallada abierta para asegurar que la sección sea visible
      sessionStorage.removeItem('bibliografiaFromHeader')
      sessionStorage.removeItem('selectedSchool')
      
      // Notificar a HomePage que cierre la vista detallada si está abierta
      window.dispatchEvent(new CustomEvent('bibliografia-detailed-view-changed', {
        detail: { show: false }
      }))
      
      // Esperar un momento a que el DOM se actualice y la sección se renderice
      setTimeout(() => {
        const section = document.getElementById('servicios-presenciales')
        if (section) {
          const headerHeight = 80
          const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - headerHeight
          
          window.scrollTo({
            top: sectionPosition,
            behavior: 'smooth'
          })
          
          // Actualizar estados de navegación
          this.isAtTop = false
          this.isInBibliografia = false
          this.isInBibliotecas = false
        }
      }, 100)
    },
    scrollToSitiosRecomendados() {
      this.hideRecursosDropdown()
      this.closeMobileMenu()
      
      // Buscar la sección de sitios recomendados
      const sitiosSection = document.getElementById('sitios-recomendados')
      if (sitiosSection) {
        const headerHeight = 80
        const sectionPosition = sitiosSection.getBoundingClientRect().top + window.pageYOffset - headerHeight
        
        window.scrollTo({
          top: sectionPosition,
          behavior: 'smooth'
        })
      } else {
        // Si no existe el ID, intentar buscar por clase o selector
        const section = document.querySelector('.sitios-section')
        if (section) {
          const headerHeight = 80
          const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - headerHeight
          
          window.scrollTo({
            top: sectionPosition,
            behavior: 'smooth'
          })
        }
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
    },
    toggleSection(section) {
      this.expandedSections[section] = !this.expandedSections[section]
    },
    toggleSubsection(subsectionId) {
      this.expandedSubsections[subsectionId] = !this.expandedSubsections[subsectionId]
    },
    getLibrariesByRegion(regionId) {
      return this.libraries.filter(lib => lib.region === regionId)
    },
    async loadLibraries() {
      // Endpoint 'bibliotecas' no existe en Strapi, usar datos locales
      // try {
      //   const response = await strapiService.getCollection('bibliotecas', {
      //     populate: '*'
      //   })
      //   this.libraries = response.data || []
      // } catch (error) {
      //   // Datos de ejemplo si falla la carga - mismos datos que BibliotecasSection
      // }
      // Usar datos locales directamente
      this.libraries = [
          // Región Metropolitana
          {
            id: 1,
            name: 'Biblioteca Grajales',
            region: 'metropolitana'
          },
          {
            id: 2,
            name: 'Biblioteca Ejército',
            region: 'metropolitana'
          },
          {
            id: 3,
            name: 'Biblioteca San Joaquín',
            region: 'metropolitana'
          },
          // Zona Norte
          {
            id: 4,
            name: 'Biblioteca Antofagasta',
            region: 'norte'
          },
          {
            id: 5,
            name: 'Biblioteca La Serena',
            region: 'norte'
          },
          {
            id: 6,
            name: 'Biblioteca Iquique',
            region: 'norte'
          },
          {
            id: 13,
            name: 'Biblioteca Arica',
            region: 'norte'
          },
          {
            id: 14,
            name: 'Biblioteca Copiapó',
            region: 'norte'
          },
          {
            id: 15,
            name: 'Biblioteca Calama',
            region: 'norte'
          },
          {
            id: 16,
            name: 'Biblioteca Coquimbo',
            region: 'norte'
          },
          // Zona Centro
          {
            id: 7,
            name: 'Biblioteca Valparaíso',
            region: 'centro-costa'
          },
          {
            id: 8,
            name: 'Biblioteca Viña del Mar',
            region: 'centro-costa'
          },
          {
            id: 9,
            name: 'Biblioteca Rancagua',
            region: 'sur'
          },
          // Zona Sur
          {
            id: 10,
            name: 'Biblioteca Concepción',
            region: 'sur'
          },
          {
            id: 11,
            name: 'Biblioteca Temuco',
            region: 'sur'
          }
        ]
    },
    navigateToLibrary(library) {
      this.closeMobileMenu()
      // Navegar a la sección de bibliotecas
      this.scrollToSection('#bibliotecas', { preventDefault: () => {} })
      
      // Esperar a que se complete el scroll y luego buscar la tarjeta de la biblioteca
      setTimeout(() => {
        const bibliotecasSection = document.getElementById('bibliotecas')
        if (bibliotecasSection) {
          // Primero, seleccionar la región correspondiente si hay tabs
          const regionTabs = bibliotecasSection.querySelectorAll('.region-tab')
          regionTabs.forEach(tab => {
            const tabText = tab.textContent.trim()
            const regionName = this.regions.find(r => r.id === library.region)?.name
            if (tabText === regionName) {
              tab.click()
            }
          })
          
          // Esperar un poco más para que se actualice el contenido con la región seleccionada
          setTimeout(() => {
            const libraryCards = bibliotecasSection.querySelectorAll('.library-card')
            
            // Buscar la tarjeta de la biblioteca
            libraryCards.forEach(card => {
              const nameElement = card.querySelector('.library-name')
              if (nameElement) {
                const cardName = nameElement.textContent.trim()
                if (cardName === library.name) {
                  // Hacer scroll hasta la tarjeta
                  card.scrollIntoView({ behavior: 'smooth', block: 'center' })
                  // Resaltar la tarjeta brevemente
                  card.style.transition = 'box-shadow 0.3s'
                  card.style.boxShadow = '0 0 20px rgba(36, 51, 78, 0.5)'
                  setTimeout(() => {
                    card.style.boxShadow = ''
                  }, 2000)
                }
              }
            })
          }, 300)
        }
      }, 600)
    },
    checkLibrosDigitales() {
      // Esperar un poco para asegurar que el DOM esté actualizado
      setTimeout(() => {
        const digitalesButton = document.querySelector('.hero .tab.active')
        if (digitalesButton) {
          const buttonText = digitalesButton.textContent.trim()
          this.isLibrosDigitales = buttonText === 'Libros digitales'
        } else {
          this.isLibrosDigitales = false
        }
      }, 50)
    },
    observeHeroSection() {
      // Verificar periódicamente si el HeroSection está disponible
      const checkInterval = setInterval(() => {
        const heroSection = document.querySelector('.hero .widget-tabs')
        if (heroSection) {
          clearInterval(checkInterval)
          
          // Observar cambios en los tabs del HeroSection
          const observer = new MutationObserver(() => {
            this.checkLibrosDigitales()
          })
          
          observer.observe(heroSection, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          })
          
          // También escuchar clicks en los tabs
          const tabs = document.querySelectorAll('.hero .tab')
          tabs.forEach(tab => {
            tab.addEventListener('click', () => {
              setTimeout(() => {
                this.checkLibrosDigitales()
              }, 100)
            })
          })
          
          // Verificación inicial
          this.checkLibrosDigitales()
        }
      }, 100)
      
      // Limpiar el intervalo después de 5 segundos si no se encuentra
      setTimeout(() => {
        clearInterval(checkInterval)
      }, 5000)
    },
    navigateToSchool(school) {
      this.closeMobileMenu()
      // Mapear el ID de la escuela al schoolKey correspondiente (igual que en desktop)
      const schoolIdToKeyMap = {
        1: 'administracion',
        2: 'artes',
        3: 'desarrollo',
        4: 'estetica',
        5: 'gastronomia',
        6: 'ingenieria',
        7: 'salud'
      }
      
      // Obtener el schoolKey basado en el ID de la escuela
      const schoolKey = schoolIdToKeyMap[school.id]
      
      if (schoolKey) {
        // Guardar la escuela seleccionada en sessionStorage (igual que desktop)
        sessionStorage.setItem('selectedSchool', schoolKey)
        // Navegar a bibliografía usando el mismo método que desktop
        this.navigateToBibliografia()
      } else {
        // Fallback: usar el nombre para buscar el schoolKey
        const schoolNameToKeyMap = {
          'Administración y Gestión Empresarial': 'administracion',
          'Artes e Industrias Creativa': 'artes',
          'Desarrollo Social y Educación': 'desarrollo',
          'Estética Integral': 'estetica',
          'Gastronomía, Hotelería y Turismo': 'gastronomia',
          'Ingeniería, Energía y Tecnología': 'ingenieria',
          'Salud y Deporte': 'salud'
        }
        
        const schoolKeyByName = schoolNameToKeyMap[school.name] || schoolNameToKeyMap[school.searchName]
        if (schoolKeyByName) {
          sessionStorage.setItem('selectedSchool', schoolKeyByName)
          this.navigateToBibliografia()
        }
      }
    }
  }
}
</script>

<style scoped>
.top-bar-wrapper {
  width: 100%;
}

.top-bar-white {
  width: 100%;
  background: var(--white);
  padding: 12px 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.top-bar-white.hide-on-digitales {
  display: none;
}

@media (max-width: 1150px) {
  .top-bar-wrapper {
    display: none;
  }
}

.top-bar-links {
  display: flex;
  gap: 24px;
  align-items: center;
}

.top-link {
  color: #182844;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  transition: color 0.3s;
}

.top-link:hover {
  color: var(--primary-blue);
}

.header {
  background-color: #182844;
  color: var(--white);
  padding: 16px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 1151px) {
  .header {
    height: 107px;
    padding: 0;
    display: flex;
    align-items: center;
  }
  
  .header-container {
    max-width: 1200px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    gap: 4px;
  }
  
  .logo {
    flex-shrink: 1;
    min-width: 0;
    max-width: 320px;
  }
  
  .header-right {
    flex: 0 1 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex-shrink: 0;
    margin-left: 8px;
  }
  
  .nav {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0px;
    align-items: center;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .nav-link {
    padding: 8px 6px;
    font-size: 14px;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  min-width: 0;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  align-items: center;
  justify-content: center;
}

.menu-icon-svg {
  display: none;
}

.logo {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.logo svg {
  display: block;
  height: auto;
}

.logo-text-desktop {
  display: block;
  width: auto;
  height: 60px;
  max-width: 360px;
}

@media (min-width: 1151px) {
  .logo-text-desktop {
    height: 60px;
    max-width: 320px;
  }
}

.nav {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 24px;
  align-items: center;
  white-space: nowrap;
}

.nav-link {
  color: var(--white);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border-radius: 4px;
  white-space: nowrap;
  cursor: default;
  user-select: none;
}

.nav-link:hover {
  opacity: 0.8;
}

.nav-link.active {
  background-color: #003366;
}

.dropdown-icon {
  width: 13px;
  height: 7px;
  flex-shrink: 0;
  display: inline-block;
  margin-left: 2px;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.nav-link-wrapper {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 243px;
  height: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  z-index: 1000;
  padding: 16px 0;
  margin-top: 4px;
}

/* Puente para evitar que el menú se cierre al mover el ratón hacia abajo */
.dropdown-menu::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 10px;
  background: transparent;
}

@media (min-width: 1151px) {
  .dropdown-menu.dropdown-escuelas {
    width: 285px;
  }
  
  .dropdown-menu.dropdown-recursos {
    width: 300px;
  }
  
  .dropdown-menu.dropdown-servicios {
    width: 280px;
  }
}

.dropdown-menu.active {
  opacity: 1;
  visibility: visible;
}

.dropdown-item {
  display: block;
  padding: 12px 24px;
  color: #1a2b49;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  border-bottom: 1px solid #E0E0E0;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background-color: #F5F5F5;
}

.dropdown-accordion {
  border-bottom: 1px solid #E0E0E0;
}

.dropdown-accordion:last-child {
  border-bottom: none;
}

.dropdown-accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  color: #1a2b49;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
  background-color: white;
}

.dropdown-accordion-header:hover {
  background-color: #F8F8F8;
}

.dropdown-accordion-header.active {
  background-color: #F8F8F8;
}

.dropdown-chevron {
  width: 12px;
  height: 12px;
  color: #1a2b49;
  flex-shrink: 0;
}

.dropdown-chevron.rotated {
  transform: rotate(180deg);
}

.dropdown-accordion-content {
  background-color: white;
  overflow: hidden;
}

.dropdown-subitem {
  padding: 12px 24px 12px 36px;
  font-weight: 400;
  border-bottom: none;
}

.dropdown-subitem:hover {
  background-color: #F5F5F5;
}


@media (max-width: 1150px) {
  .nav {
    display: none;
  }
  
  .user-icon-svg {
    display: none;
  }
  
  .mobile-menu-btn {
    display: flex;
  }
  
  .menu-icon-svg {
    display: block;
  }
  
  .logo-text-desktop {
    display: block;
    height: 40px;
    max-width: 250px;
  }
}

/* Menú lateral móvil */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  opacity: 0;
  visibility: hidden;
}

.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 75%;
  max-width: 320px;
  height: 100%;
  background-color: white;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 0 20px;
  overflow-y: auto;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.mobile-menu.active {
  right: 0;
}

.mobile-menu-header {
  padding: 24px 20px;
  background-color: white;
  border-bottom: 1px solid #E0E0E0;
}

.welcome-text {
  color: #24334E;
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: bold;
  text-align: center;
}

.login-button {
  width: 100%;
  max-width: 253px;
  height: 33px;
  padding: 0 24px;
  background-color: #CE1B1B;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-decoration: none;
}

.login-button:hover {
  background-color: #B01717;
}

.mobile-menu-content {
  flex: 1;
  padding: 0;
}

.menu-section {
  border-bottom: 1px solid #E0E0E0;
}

.menu-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: white;
  color: #24334E;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.menu-section-header:hover {
  background-color: #F5F5F5;
}

.menu-section-header.active {
  background-color: #F5F5F5;
  color: #24334E;
}

.chevron-icon {
  width: 12px;
  height: 12px;
  color: #24334E;
}

.chevron-icon.rotated {
  transform: rotate(180deg);
}

.menu-section-content {
  background-color: #F5F5F5;
  overflow: hidden;
}

.menu-item {
  padding: 14px 20px 14px 40px;
  background-color: #F5F5F5;
  color: #24334E;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #E8E8E8;
}

.menu-item:hover {
  background-color: #EEEEEE;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-subsection {
  border-top: 1px solid #E8E8E8;
}

.menu-subsection:first-child {
  border-top: none;
}

.menu-subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px 12px 40px;
  background-color: #F5F5F5;
  color: #24334E;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.menu-subsection-header:hover {
  background-color: #EEEEEE;
}

.menu-subsection-content {
  background-color: #F5F5F5;
  overflow: hidden;
}

.menu-subsection-content .menu-item {
  padding: 12px 20px 12px 60px;
  border-bottom: 1px solid #E8E8E8;
}

.menu-subsection-content .menu-item:last-child {
  border-bottom: none;
}

@media (max-width: 1150px) {
  .welcome-text {
    margin-bottom: 8px;
  }
}
</style>

